import React from "react";

type Props = {
  value: string;
  onChange: (value: string) => void;
  invalid: boolean;
};

export function LocationSettings({ value, onChange, invalid }: Props): React.JSX.Element {
  return (
    <div className="border-t border-ink-200 pt-4 mt-4">
      <div className="mb-1">
        <p className="text-[13px] font-medium text-ink-900">Link de Google Maps</p>
        <p className="text-[12px] text-ink-500 mt-0.5">
          El agente comparte este enlace cuando preguntan por la ubicación o cómo llegar.
        </p>
      </div>

      <input
        type="url"
        inputMode="url"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={500}
        placeholder="https://maps.app.goo.gl/…"
        className={`mt-3 w-full text-[13px] border rounded-lg px-3 py-1.5 focus:outline-none text-ink-900 placeholder:text-ink-300 bg-white ${
          invalid ? "border-red-400 focus:border-red-500" : "border-ink-200 focus:border-moss"
        }`}
      />
      {invalid && (
        <p className="text-[11px] text-red-500 mt-1">
          Ingresa una URL válida que empiece con https:// o http://
        </p>
      )}
    </div>
  );
}
